/* eslint-disable no-unused-vars */
import React from 'react';
import style from './sorting.module.scss';
import { ResourceSortType, UsersSortType } from 'store/types';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { MenuItem, Select } from '@mui/material';
import map from 'lodash-es/map';
import SortIcon from '@mui/icons-material/Sort';

const texts: { [x: string]: string } = {
  '-likes': '↓ Лайки',
  '%2Blikes': '↑ Лайки',
  '-views': '↓ Просмотры',
  '%2Bviews': '↑ Просмотры',
  '-downloads': '↓ Загрузки',
  '%2Bdownloads': '↑ Загрузки',
  '-created_at': '↓ Дата создания',
  '%2Bcreated_at': '↑ Дата создания',

  '-register_date': '↓ По дате регистрации',
  '%2Bregister_date': '↑ По дате регистрации',
};

export default function Sorting({
  items,
  startURL,
  defaultSelectedValue = items[0],
}: {
  items: ResourceSortType[] | UsersSortType[];
  startURL: string;
  defaultSelectedValue?: string;
}) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const sortInSearch = searchParams.get('sort');

  return (
    <div className={style.container}>
      <Select
        className={style.select}
        variant="standard"
        value={sortInSearch ? sortInSearch : defaultSelectedValue}
        onChange={(event) => {
          searchParams.set('sort', event.target.value);
          navigate(`${startURL}${searchParams.toString()}`, {
            replace: false,
          });
        }}
        MenuProps={{
          disableScrollLock: true,
        }}
        disableUnderline={true}
      >
        {map(items, (item, i) => {
          return (
            <MenuItem key={i} value={item}>
              {texts[item]}
            </MenuItem>
          );
        })}
      </Select>
      <SortIcon></SortIcon>
    </div>
  );
}
